import QRCode from "qrcode";

/** An SVG QR code for `text`, as markup generated by the qrcode library. */
export function qrSvg(text: string): Promise<string> {
  return QRCode.toString(text, { type: "svg", margin: 1, errorCorrectionLevel: "M" });
}

/** Mounts a QR code into `el`. The SVG comes from the library, not from user input. */
export async function renderQr(el: HTMLElement, text: string): Promise<void> {
  el.innerHTML = await qrSvg(text);
}
